module.exports = __webpack_public_path__ + "img/18.d822581c.jpg";